import React from 'react'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import {
  metersToFeet,
  getFormattedNumber
} from '../../../../../../../../common/utils'
import Status from '../status'

class FiberSetReferenceLengthTable extends React.Component {
  constructor(props) {
    super(props)
  }

  lengthUnitConverter = (length) => {
    const { chartMeasurementUnit } = this.props
    if (chartMeasurementUnit === 'feet') {
      return metersToFeet(length)
    }
    return getFormattedNumber(length)
  }

  render() {
    const {
      setreference,
      translate,
      classes,
      chartMeasurementUnit
    } = this.props

    const measurementUnit = chartMeasurementUnit === 'feet' ? "" : `(${translate('m')})`
    const lengthData = setreference.length;

    return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>{translate('fiber_result')}</TableCell>
            <TableCell numeric>{translate('fiber_refractiveindex')}</TableCell>
            <TableCell numeric>{translate('fiber_length')}{measurementUnit}</TableCell>
            <TableCell numeric>{translate('fiber_lengthlimit')}{measurementUnit}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow >
            <TableCell>{lengthData.result ? (<React.Fragment> <Status status={lengthData.result} /></React.Fragment>) : (translate('general_na'))}</TableCell>
            <TableCell numeric>{lengthData.refractiveindex}</TableCell>
            <TableCell numeric>{(lengthData.length !== null) ? this.lengthUnitConverter(lengthData.length) : (translate('general_na'))}</TableCell>
            <TableCell numeric>{this.lengthUnitConverter(lengthData.lengthlimit)}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
    )
  }
}

export default withStyles(styles)(FiberSetReferenceLengthTable)

